import React from 'react';
import { i18n } from 'fishx';
import { Modal } from '@whalecloud/fdx';

const COMMONFOOTER = {
  okText: i18n('COMMON_CONFIRM'),
  cancelText: i18n('COMMON_CANCEL'),
};

const { confirm } = Modal;

interface CommonType {
  onOk: Function,
  [x: string]: any,
}

interface PropsType {
  modalOpts: Object,
  children: any,
}

export const commonConfirm = ({ onOk, ...otherProps }: CommonType) => {
  const confirmCommonProps = {
    title: i18n('COMMON_CONFIRM'),
    ...COMMONFOOTER,
  };
  confirm({
    ...confirmCommonProps,
    ...otherProps,
    onOk: () => {
      onOk();
    },
  });
};

export default function CommonModal(props: PropsType) {
  const modalCommonProps = {
    title: i18n('COMMON_MODAL'),
    visible: true,
    width: 'calc(100% - 300px)',
    wrapClassName: 'modal-container',
    centered: true,
    maskClosable: false,
    destroyOnClose: true,
    ...COMMONFOOTER,
  };
  const { modalOpts, children } = props;
  return (
    <Modal {...modalCommonProps} {...modalOpts}>
      {children}
    </Modal>
  );
}
